import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { TagTheme } from '@fcom/ui-components';
import { ServiceCatalogService } from '@fcom/dapi/interfaces/services.interface';
import { getIconForServiceCategory } from '@fcom/dapi/utils/service-category-utils';

import { hasProductInfoModal } from '../../../utils/bundles.utils';

@Component({
  selector: 'fin-bundle-service-card',
  templateUrl: './bundle-service-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  host: {
    class: 'flex flex--nowrap flex-1 flex--basis0 ps-medium rounded-large dashed-border-secondary',
    '[class.dashed-box]': '!inCart()',
    '[class.surface-secondary]': 'inCart()',
  },
})
export class BundleServiceCardComponent {
  readonly service = input.required<ServiceCatalogService>();
  readonly inCart = input(false);

  readonly TagTheme = TagTheme;

  modalOpen = false;

  readonly icon = computed(() => getIconForServiceCategory(this.service().category));
  readonly hasModal = computed(() => hasProductInfoModal(this.service().category));
}
